import { compose, filter, map, values } from 'ramda';
import { createSelector } from 'reselect';

import user from 'features/views/user';

import { byAgencyId, byChannelId, byRegionId, restrictBy, toUserName } from '../utils';
import { selectors } from './reducer';

export const getAllManagers = selectors.getData;

export const getManagers = createSelector(
	(_, formData) => formData?.channel,
	(_, formData) => formData?.region,
	(_, formData) => formData?.agency,
	getAllManagers,
	user.selectors.getAllowedManagers,
	(channelId, regionId, agencyId, managers, allowedManagers) =>
		compose(
			map(toUserName),
			restrictBy(allowedManagers),
			filter(byAgencyId(agencyId)),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
			values,
		)(managers),
);

export const getManagersForSidebar = createSelector(
	(state, formData) => formData?.channel,
	(state, formData) => formData?.region,
	(state, formData) => formData?.agency,
	getAllManagers,
	user.selectors.getAllowedManagers,
	(state, formData, customAllowedManagers) => customAllowedManagers,
	(channelId, regionId, agencyId, managers, baseAllowedManagers, customAllowedManagers) =>
		compose(
			map(toUserName),
			restrictBy(customAllowedManagers),
			restrictBy(baseAllowedManagers),
			filter(byAgencyId(agencyId)),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
			values,
		)(managers),
);
